import clsx from "clsx";
import { useId, useState } from "react";
import { FieldHint } from "@/components/FieldHint";
import { getEmailHint } from "@/lib/emailHints";

type Props = {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  missing?: boolean;
  className?: string;
  id?: string;
  autoComplete?: string;
};

export function EmailInput({
  value,
  onChange,
  required,
  missing = false,
  className = "bk-input mt-1",
  id: idProp,
  autoComplete = "email",
}: Props) {
  const autoId = useId();
  const inputId = idProp ?? autoId;
  const hintId = `${inputId}-hint`;
  const [touched, setTouched] = useState(false);

  const hint = touched ? getEmailHint(value) : null;

  return (
    <>
      <input
        id={inputId}
        type="email"
        className={clsx(className, missing && "bk-input--missing")}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={() => setTouched(true)}
        autoComplete={autoComplete}
        inputMode="email"
        required={required}
        aria-invalid={hint || missing ? true : undefined}
        aria-describedby={hint ? hintId : undefined}
      />
      {hint ? <FieldHint id={hintId}>{hint.message}</FieldHint> : null}
    </>
  );
}
